(function () {
  var configEl = document.getElementById('sv-cart-offers-config');
  if (!configEl) return;
  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!config.enabled || !config.tiers || !config.tiers.length) return;

  var CHOICE_KEY = 'svOfferChoice';
  var OPEN_KEY = 'svOffersOpen';
  var PRELAUNCH_KEY = 'svPrelaunch';
  var REGISTERED_KEY = 'svPrelaunchPhones';

  // Registered on the pre-launch page from this browser, or arrived via the WhatsApp ?offer=prelaunch link.
  // This only decides what to pre-fill; Fastrr checks the phone number and the one-use limit.
  function isPrelaunchShopper() {
    var pre = config.prelaunch;
    if (!pre || !pre.code) return false;
    var until = Date.parse(pre.until);
    if (until && Date.now() > until) return false;
    try {
      if (new URLSearchParams(window.location.search).get('offer') === 'prelaunch') {
        localStorage.setItem(PRELAUNCH_KEY, '1');
      }
      if (localStorage.getItem(PRELAUNCH_KEY) === '1') return true;
      var phones = JSON.parse(localStorage.getItem(REGISTERED_KEY));
      return !!(phones && phones.length);
    } catch (e) {
      return false;
    }
  }

  var prelaunch = isPrelaunchShopper();

  function amountOff(li) {
    return parseInt(String(li.dataset.off || '').replace(/\D/g, ''), 10) || 0;
  }

  function store(key, value) {
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function read(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function bestFor(count) {
    var best = null;
    config.tiers.forEach(function (t) {
      if (count >= t.min && (!best || t.min > best.min)) best = t;
    });
    return best;
  }

  // Fastrr pre-fills its coupon box from the discount_code cookie.
  function setDiscountCookie(code) {
    if (code) {
      document.cookie = 'discount_code=' + encodeURIComponent(code) + '; path=/; SameSite=Lax';
    } else {
      document.cookie = 'discount_code=; path=/; max-age=0';
    }
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setHidden(el, hidden) {
    if (el && el.hidden !== hidden) el.hidden = hidden;
  }

  function scopes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-sv-offers-scope]'));
  }

  // A manual pick sticks until the item count changes; otherwise the best eligible offer is used.
  function selectedOffer(list) {
    var count = parseInt(list.dataset.itemCount, 10) || 0;
    var eligible = Array.prototype.slice.call(list.querySelectorAll('[data-sv-offer].is-eligible:not([hidden])'));
    var choice = null;
    try {
      choice = JSON.parse(read(CHOICE_KEY));
    } catch (e) {}
    if (choice && choice.count === count) {
      var picked = eligible.find(function (li) { return li.dataset.code === choice.code; });
      if (picked) return picked;
    }
    if (!config.autoApply) return null;
    var best = null;
    var pre = null;
    eligible.forEach(function (li) {
      if (li.hasAttribute('data-prelaunch')) {
        pre = li;
        return;
      }
      if (!best || Number(li.dataset.min) > Number(best.dataset.min)) best = li;
    });
    // The pre-launch code drops the prepaid discount and combines with nothing, so a bigger cart offer still wins.
    if (pre && (!best || amountOff(best) < amountOff(pre))) return pre;
    return best;
  }

  function decorate(scope) {
    var list = scope.querySelector('[data-sv-cart-offers]');
    var summary = scope.querySelector('[data-sv-cart-summary]');
    var strip = scope.querySelector('[data-sv-offers-strip]');

    if (list) {
      list.querySelectorAll('[data-prelaunch]').forEach(function (li) {
        setHidden(li, !prelaunch);
      });
    }
    scope.querySelectorAll('[data-sv-prelaunch-teaser]').forEach(function (el) {
      setHidden(el, !prelaunch);
    });

    var selected = list ? selectedOffer(list) : null;

    // Fastrr drops the prepaid discount when the pre-launch code is applied, so don't promise it.
    var prepaidOff = !!selected && selected.hasAttribute('data-prelaunch');
    scope.querySelectorAll('[data-sv-prepaid-note]').forEach(function (el) {
      setHidden(el, prepaidOff);
    });

    if (list) {
      list.querySelectorAll('[data-sv-offer]').forEach(function (li) {
        li.classList.toggle('is-selected', li === selected);
      });
      var wantOpen = read(OPEN_KEY) === '1';
      if (list.open !== wantOpen) list.open = wantOpen;
    }

    if (strip) {
      setHidden(strip.querySelector('[data-sv-strip-applied]'), !selected);
      setHidden(strip.querySelector('[data-sv-strip-none]'), !!selected);
      if (selected) {
        setText(strip.querySelector('[data-sv-strip-code]'), selected.dataset.code);
        setText(strip.querySelector('[data-sv-strip-off]'), selected.dataset.off);
      }
      var hideProgress =
        !!selected &&
        selected.hasAttribute('data-prelaunch') &&
        (Number(strip.dataset.nextOff) || 0) <= amountOff(selected);
      strip.querySelectorAll('[data-sv-strip-progress]').forEach(function (el) {
        setHidden(el, hideProgress);
      });
    }

    if (summary) {
      setHidden(summary.querySelector('[data-sv-sum-off-row]'), !selected);
      if (selected) {
        setText(summary.querySelector('[data-sv-sum-code]'), selected.dataset.code);
        setText(summary.querySelector('[data-sv-sum-off]'), '−' + selected.dataset.off);
      }
      setText(summary.querySelector('[data-sv-sum-pay]'), selected ? selected.dataset.pay : summary.dataset.basePay);
      setText(
        summary.querySelector('[data-sv-sum-pay-prepaid]'),
        selected ? selected.dataset.payPrepaid : summary.dataset.basePayPrepaid
      );
    }

    var countEl = scope.querySelector('[data-sv-cart-count]');
    if (countEl && summary) {
      var n = parseInt(summary.dataset.itemCount, 10) || 0;
      setText(countEl, n > 0 ? '(' + n + ')' : '');
    }

    return selected;
  }

  function decorateAll() {
    var code = '';
    scopes().forEach(function (scope) {
      var selected = decorate(scope);
      if (selected && !code) code = selected.dataset.code;
    });
    setDiscountCookie(code);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target.closest) return;

    var applyBtn = target.closest('[data-sv-offer-apply]');
    if (applyBtn) {
      e.preventDefault();
      var list = applyBtn.closest('[data-sv-cart-offers]');
      var count = list ? parseInt(list.dataset.itemCount, 10) || 0 : 0;
      store(CHOICE_KEY, JSON.stringify({ code: applyBtn.getAttribute('data-sv-offer-apply'), count: count }));
      decorateAll();
      return;
    }

    var openBtn = target.closest('[data-sv-offers-open]');
    if (openBtn) {
      e.preventDefault();
      var scope = openBtn.closest('[data-sv-offers-scope]');
      var offers = scope && scope.querySelector('[data-sv-cart-offers]');
      if (offers) {
        offers.open = true;
        store(OPEN_KEY, '1');
        offers.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }

    var fastrr = target.closest('.shiprocket-headless');
    if (!fastrr) return;
    if (fastrr.dataset.type === 'product') {
      var qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      var best = config.autoApply ? bestFor(parseInt(qtyInput && qtyInput.value, 10) || 1) : null;
      if (config.autoApply && prelaunch && (!best || best.off < config.prelaunch.off)) best = config.prelaunch;
      setDiscountCookie(best ? best.code : '');
    } else {
      decorateAll();
    }
  }, true);

  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('[data-sv-cart-offers]')) {
      store(OPEN_KEY, e.target.open ? '1' : null);
    }
  }, true);

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      decorateAll();
    });
  });
  scopes().forEach(function (scope) {
    observer.observe(scope, { childList: true, subtree: true });
  });

  decorateAll();
})();
